import { useState } from 'react'

export const CHART_TYPES = {
  PIE: 'pie',
  LINE: 'line',
  BAR: 'bar'
}

// Default is always the pie chart unless the user has explicitly picked
// something else before. Falls back to the default for any stored value
// that's no longer valid.
export const useChartType = () => {
  const [chartType, setChartTypeState] = useState(() => {
    const stored = localStorage.getItem('dashboardChartType')
    return Object.values(CHART_TYPES).includes(stored) ? stored : CHART_TYPES.PIE
  })

  const setChartType = (type) => {
    setChartTypeState(type)
    localStorage.setItem('dashboardChartType', type)
  }

  return { chartType, setChartType }
}
